// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Box, useTheme, SxProps, Theme } from '@mui/system';
import logo from 'Assets/aw-horizontal-navy.png';

interface DialogLogoProps {
  wrapperSx?: SxProps<Theme>;
  logoStyle?: React.CSSProperties;
}

const DialogLogo = ({ wrapperSx, logoStyle }: DialogLogoProps) => {
  const theme = useTheme();

  const defaultWrapperSx: SxProps<Theme> = {
    position: 'fixed',
    top: theme.spacing(4),
    left: theme.spacing(5),
    zIndex: 2000,
  };

  const defaultLogoStyle: React.CSSProperties = {
    height: theme.spacing(4),
    width: 'auto',
  };

  return (
    <Box sx={{ ...defaultWrapperSx, ...wrapperSx }}>
      <img src={logo} alt="AirWorks" style={{ ...defaultLogoStyle, ...logoStyle }} />
    </Box>
  );
};

export default DialogLogo;
